{
  "version": 1,
  "asset_id": "c4359762-6a68-4c25-973d-7182552c32ea",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/c4359762-6a68-4c25-973d-7182552c32ea/clip-img_2179-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/c4359762-6a68-4c25-973d-7182552c32ea/clip-img_2179-poster-sm.webp",
  "original_filename": "clip-img_2179-poster-sm.webp",
  "size": 10866,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:35Z"
}
